<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Quotes" searchable="true"></list-nav-header>


            <list-nav-scroll>
                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items" class="no-icons">
                        <div class="info">
                            <span>{{ item.package.data.project }}</span>
                            <span>{{ item.created_at }}</span>
                            <span>{{ item.package.data.name }}</span>
                            <span>£{{ item.costs.total }}</span>
                        </div>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Purchase Orders
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                    <tr>
                        <th scope="col">Reference</th>
                        <th scope="col">Package</th>
                        <th scope="col">Created</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Owner</th>
                        <th scope="col">Locked</th>
                        <th scope="col">Secured</th>
                        <th scope="col">Sub Total</th>
                        <th scope="col">Markup</th>
                        <th scope="col">Estimated Profit</th>
                        <th scope="col">Total Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Reference">{{ item.reference }}</td>
                        <td data-label="Package"><a :href="item.package.data._links.frontend.view">{{
                            item.package.data.name }}</a></td>
                        <td data-label="Created">{{ item.created_at }}</td>
                        <td data-label="Created By">{{ item.created_by.name }}</td>
                        <td data-label="Owner">{{ item.owned_by.name }}</td>
                        <td data-label="Locked">{{ item.is_locked | human_bool }}</td>
                        <td data-label="Secured">{{ item.is_secured | human_bool }}</td>
                        <td data-label="Sub Total">&pound;{{ item.costs.subtotal }}</td>
                        <td data-label="Markup">&pound;{{ item.costs.markup }}</td>
                        <td data-label="Estimated Profit">&pound;{{ item.costs.estimated_profit }}</td>
                        <td data-label="Total Value">&pound;{{ item.costs.total }}</td>
                    </tr>
                    <tr>
                        <td colspan="11">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Quotes
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props:['packageId'],
        data() {
            return {
                name: 'quotes',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {

        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.quotes.index;
                var params = {};

                if (this.packageId) {
                    params.package = this.packageId;
                }

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
